import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { KBFormError, KBButton, KBUserInput, KBASNumberInput } from 'components';
import { bindActionCreators } from 'redux';
import * as selectors from 'app/selectors';
import { successState } from 'app/actions';
import { api, apiUtils } from 'app/services';
import { KBSelect } from 'components/views';
import { reduxForm } from 'redux-form';
import { withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';

var SpaceSettingServiceForm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;

    updateCurrentSpace(
    {
      settings: JSON.stringify({
        service_provider_settings: model }) },


    {
      key: 'service_provider_settings' });


  }render()
  {
    const {
      fields: { service_request_follow_up_cycle },
      submitting,
      handleSubmit } =
    this.props;

    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <div className="kb-row">
            <div className="f-left">
              <label>服务申请跟踪周期(天), 默认1天</label>
            </div>
            <KBASNumberInput
            field={service_request_follow_up_cycle}
            className="f-right"
            type="number" />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const settings = setting.service_provider_settings || {};
  let setting_value = settings.service_request_follow_up_cycle || 1;
  return {
    initialValues: { service_request_follow_up_cycle: setting_value } };

}

function mapDispatchToProps(dispatch) {
  return {
    successAction: bindActionCreators(successState, dispatch) };

}

const LEGACY_FORM_FIELDS = [
  "service_request_follow_up_cycle"
];

const formConfig = {
  form: 'SpaceSettingServiceForm',
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingServiceForm', LEGACY_FORM_FIELDS)(SpaceSettingServiceForm)));
